<div style="position: relative; padding-top: 30px;">
    <mat-icon class="close-icon" (click)="closeModal()">close</mat-icon>

    <div class="display-box">
        <mat-accordion>
            <mat-expansion-panel hideToggle *ngFor="let data of modalData">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{data.firstName}} {{data.lastName}}
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>

                </mat-expansion-panel-header>
                <form style="margin-top: 20px;">
                    <form class="row">
                        <mat-form-field class="col-6">
                            <mat-label i18n>FirstName</mat-label>
                            <input matInput placeholder="Ex. William" [(ngModel)]="data.firstName" autocomplete="off"
                                name="firstname">
                            <mat-hint i18n style="color: #f44336;" *ngIf="data.firstName=='n/a' || data.firstName==''">
                                Please enter a valid info
                            </mat-hint>
                        </mat-form-field>

                        <mat-form-field class="col-6">
                            <mat-label i18n>LastName</mat-label>
                            <input matInput placeholder="Ex. Clinton" [(ngModel)]="data.lastName" autocomplete="off"
                                name="lastname">
                            <mat-hint i18n style="color: #f44336;" *ngIf="data.lastName=='n/a' || data.lastName==''">
                                Please enter a valid info
                            </mat-hint>
                        </mat-form-field>
                    </form>


                    <form class="row">
                        <mat-form-field class="col-12">
                            <mat-label i18n>Birth Place</mat-label>
                            <input matInput placeholder="Ex. Coffee Co. AL" [(ngModel)]="data.birth.place"
                                autocomplete="off" name="birthplace">
                            <mat-hint i18n style="color: #f44336;" *ngIf="data.birth.place=='n/a' || data.birth.place==''">
                                Please enter a valid info
                            </mat-hint>
                        </mat-form-field>
                    </form>
                    <form class="row">
                        <mat-form-field class="col-4">
                            <mat-label i18n>Birth Year</mat-label>
                            <input matInput placeholder="Ex. 1888" [(ngModel)]="data.birth.date.year" autocomplete="off"
                                name="birthyear">
                            <mat-hint i18n style="color: #f44336;"
                                *ngIf="data.birth.date.year=='-' || data.birth.date.year==''">
                                Please enter a valid info
                            </mat-hint>
                        </mat-form-field>
                        <mat-form-field class="col-4">
                            <mat-label i18n>Birth Month</mat-label>
                            <input matInput placeholder="Ex. 1" [(ngModel)]="data.birth.date.month" autocomplete="off"
                                name="birthmonth">
                            <mat-hint i18n style="color: #f44336;"
                                *ngIf="data.birth.date.month=='-' || data.birth.date.month==''">
                                Please enter a valid info
                            </mat-hint>
                        </mat-form-field>
                        <mat-form-field class="col-4">
                            <mat-label i18n>Birth Day</mat-label>
                            <input matInput placeholder="Ex. 1" [(ngModel)]="data.birth.date.day" autocomplete="off"
                                name="birthday">
                            <mat-hint i18n style="color: #f44336;"
                                *ngIf="data.birth.date.day=='-' || data.birth.date.day==''">
                                Please enter a valid info
                            </mat-hint>
                        </mat-form-field>
                    </form>
                    <form class="row">
                        <mat-form-field class="col-12">
                            <mat-label i18n>Death Place</mat-label>
                            <input matInput placeholder="Ex. Coffee Co. AL" [(ngModel)]="data.death.place"
                                autocomplete="off" name="deathplace">
                            <mat-hint i18n style="color: #f44336;" *ngIf="data.death.place=='n/a' || data.death.place==''">
                                Please enter a valid info
                            </mat-hint>
                        </mat-form-field>
                    </form>
                    <form class="row">
                        <mat-form-field class="col-4">
                            <mat-label i18n>Death Year</mat-label>
                            <input matInput placeholder="Ex. 1888" [(ngModel)]="data.death.date.year" autocomplete="off"
                                name="deathyear">
                            <mat-hint i18n style="color: #f44336;"
                                *ngIf="data.death.date.year=='-' || data.death.date.year==''">
                                Please enter a valid info
                            </mat-hint>
                        </mat-form-field>
                        <mat-form-field class="col-4">
                            <mat-label i18n>Death Month</mat-label>
                            <input matInput placeholder="Ex. 1" [(ngModel)]="data.death.date.month" autocomplete="off"
                                name="deathmonth">
                            <mat-hint i18n style="color: #f44336;"
                                *ngIf="data.death.date.month=='-' || data.death.date.month==''">
                                Please enter a valid info
                            </mat-hint>
                        </mat-form-field>
                        <mat-form-field class="col-4">
                            <mat-label i18n>Death Day</mat-label>
                            <input matInput placeholder="Ex. 1" [(ngModel)]="data.death.date.day" autocomplete="off"
                                name="deathday">
                            <mat-hint i18n style="color: #f44336;"
                                *ngIf="data.death.date.day=='-' || data.death.date.day==''">
                                Please enter a valid info
                            </mat-hint>
                        </mat-form-field>
                    </form>
                    <button i18n mat-raised-button
                        style="background-color: #B6C1B1; color: #470037; font-size: 15px; margin: 10px; float: right;"
                        (click)="save(data)">SAVE</button>
                </form>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
    <button i18n class="done" (click)="closeModal()">Done</button>
</div>